(() => {
    const messages = document.querySelectorAll(".bss-lock-element");
    messages.forEach(message => {
        const link = message.querySelector('a[href*="/account/login"]');
        const url = new URL(link.href)
        url.searchParams.set('show_guest', 'true');
        link.href = url.toString();
    });
    if (window.location.href.includes('/account/login')) {
        if (window.location.search.includes('show_guest=true')) {
            const guestLoginWrapper = document.querySelector('.guest-login-wrapper');
            if (guestLoginWrapper) {
                guestLoginWrapper.style.display = 'block';
            }
        }
    }
})()